var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseEnrollment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2V16H2V2H16ZM16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0Z",
    fill: "#B2B3B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14H4V12H11V14ZM14 10H4V8H14V10ZM14 6H4V4H14V6Z",
    fill: "#B2B3B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseEnrollment);
export default __webpack_public_path__ + "static/media/CourseEnrollment.0b6aa18a5eef09e725a28988f4da140e.svg";
export { ForwardRef as ReactComponent };